import { Component, OnInit } from '@angular/core';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
// import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-grupos',
  templateUrl: './grupos.component.html',
  styleUrls: ['./grupos.component.scss']
})
export class GruposComponent implements OnInit {

  //boolean cargando
  cargando = false;
  tabCrear=0;
  editarCrear='FOCUS.GRUPOS.CREAR';
  eventsSubject: Subject<any> = new Subject<any>();
  datosInfoGrupo: Subject<any> = new Subject<any>();


  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
  }

  emitEventToChild() {
      this.eventsSubject.next(true);
    }

  onLinkClick(event: MatTabChangeEvent) {

    this.tabCrear= event.index;
    console.log(event);
  }

  CambioTab(numero: boolean){
    if(numero){
    this.tabCrear=1;
this.datosInfoGrupo.next(null);
  }
  }
  infoGrupoFocus(grupoInfo:any){
this.datosInfoGrupo.next(grupoInfo);

  }

   actualizarGrupos(numero: boolean){
    if(numero)
    this.emitEventToChild();
  }
  cambiarNombre(editar: string){
  this.editarCrear='FOCUS.GRUPOS.EDITAR';

  }

}
